<template>
    <div>
        <Card>
            <p slot="title"> Tambah Pembayaran </p>

            <Form :label-width="120">
                <Card style="width:450px" v-if="paymentClaimId">
                    <p slot="title" >Claim Info</p>
                    <Button
                        slot="extra"
                        size="small"
                        @click="goToPaymentClaimList()">Cancel</Button>

                    <template v-if="finishLoading">
                        <Row type="flex" justify="center" align="middle" class="code-row-bg">
                            <Col span="10">
                                {{ paymentClaim.transactionDate | dateFormatted }}
                                <h5>{{ paymentClaim.bankAccountName }}</h5>
                            </Col>
                            <Col span="12" offset="2" style="text-align:right">
                                <Tag type="border" color="blue"> {{ paymentClaim.amount | numberFormatted }} </Tag>
                            </Col>
                        </Row>
                    </template>
                </Card>
                <br/> <hr/> <br/>

                <Form-item label="Tgl Pembayaran">
                    <Row>
                        <Col span="4">
                            <Date-picker v-model="paymentDate"
                                style="width: 110px;"
                                type="date"
                                placeholder=""
                                format="dd/MM/yyyy">
                            </Date-picker>
                        </Col>
                        <Col span="2">
                            <Select
                                v-model="searchSelectSubbranch"
                                disabled
                                placeholder="Branchcode"
                                @on-change="setMarkingCode"
                                >
                                <Option v-for="subbranch, idx in subbranchs" :value="subbranch.subbranchcode" :key="idx">
                                    {{ subbranch.subbranchname }}
                                </Option>
                            </Select>
                        </Col>
                        <Col span="1">&nbsp;
                        </Col>
                        <Col span="3" v-show="paymentDate !=''">
                            <i-switch size="large" v-model="isGroup">
                                <span slot="open">Group</span>
                                <span slot="close">Mark</span>
                            </i-switch>
                        </Col>
                        <Col span="5" v-show="paymentDate !='' && isGroup == false && paymentClaimId == null ">
                            <Select
                                style="width: 250px;"
                                placeholder="Ketik Marking"
                                v-model="markingIdSelected"
                                filterable
                                clearable
                                remote
                                :remote-method="getMarkingByCode"
                                :loading="loadingGetMarking"
                                @on-change="getInvoiceData" >
                                <Option v-for="option in optionMarkings"
                                    :value="option.value"
                                    :key="option.value">{{option.label}}</Option>
                            </Select>
                        </Col>
                        <Col span="5" v-show="paymentDate !='' && isGroup == false && paymentClaimId && paymentClaimMarking == ''">
                            <Select
                                style="width: 250px;"
                                placeholder="Ketik Marking"
                                v-model="markingIdSelected"
                                filterable
                                clearable
                                remote
                                :remote-method="getMarkingByCode"
                                :loading="loadingGetMarking"
                                @on-change="getInvoiceData" >
                                <Option v-for="option in optionMarkings"
                                    :value="option.value"
                                    :key="option.value">{{option.label}}</Option>
                            </Select>
                        </Col>
                        <Col span="5" v-show="paymentDate !='' && isGroup == false && paymentClaimId && paymentClaimMarking">
                            <Input v-model="paymentClaimMarking" style="width: 200px;" disabled></Input>
                        </Col>
                        <Col span="5" v-show="paymentDate !='' && isGroup == false && paymentClaimId && paymentClaimMarking">
                            <Button
                                type="primary"
                                :loading="loadingPost"
                                @click="getInvoiceData"
                                icon="ios-search"
                                size="small">
                                    Search
                            </Button>
                        </Col>
                        <Col span="5" v-show="paymentDate !='' && isGroup == true">
                            <Select
                                style="width: 250px;"
                                placeholder="Ketik Group Name"
                                v-model="markingIdSelected"
                                filterable
                                clearable
                                remote
                                :remote-method="getGroupMarkingByCode"
                                :loading="loadingGetMarking"
                                @on-change="getInvoiceDataByGroupMarking" >
                                <Option v-for="option in optionGroupMarkings"
                                    :value="option.value"
                                    :key="option.value">{{option.label}}</Option>
                            </Select>
                        </Col>
                        <Col span="1" offset="1">
                        <Spin size="large" v-show="loadingGetPayment"></Spin>
                        </Col>
                    </Row>
                </Form-item>

                <Form-item label="Keterangan"
                    v-show="paymentDate !='' && markingIdSelected != '' && invoiceDues.length > 0 ">
                    <Input v-model="description" style="width: 300px;" ></Input>
                </Form-item>

                <Form-item label="Deposit"
                    v-show="paymentDate !='' && markingIdSelected != '' && depositRemaining != 0 ">

                    <Alert
                        style="width: 300px;"
                        type="warning" show-icon>{{ depositRemaining | currency }}
                    </Alert>
                    <font
                        style="color: red;"
                        v-if="totalUseDepositAmount > 0 && totalUseDepositAmount > depositRemaining">Terpakai {{totalUseDepositAmount | currency}} - LEBIH</font>

                    <font
                        style="color: green;"
                        v-if="totalUseDepositAmount > 0 && totalUseDepositAmount <= depositRemaining">
                            Terpakai: {{totalUseDepositAmount | currency}}, Sisa: {{ (depositRemaining - totalUseDepositAmount) | currency}}
                        </font>
                </Form-item>

                <Form-item label="Uang Diterima"
                    v-show="paymentDate !='' && markingIdSelected != '' && invoiceDues.length > 0 ">
                    <money
                        v-model="amountReceived"
                        v-bind="money"
                        class="ivu-input right"
                        style="width: 150px;"></money>

                        <font v-show="amountResidue != 0"
                            style="margin-left: 20px;">
                            Selisih &nbsp; {{amountResidue | currency}}
                        </font>
                </Form-item>

                <Form-item label="Uang Potongan"
                    v-show="paymentDate !='' && markingIdSelected != '' && invoiceDues.length > 0 && paymentClaimId ">
                    <money
                        v-model="discountReceived"
                        v-bind="money"
                        class="ivu-input right"
                        style="width: 150px;"></money>
                </Form-item>

                <Form-item label="Kategori"
                    v-show="paymentDate !='' && markingIdSelected != '' && invoiceDues.length > 0 && paymentClaimId == null">
                    <input type="radio" v-model="category" id="payment" value="pay"> <label for="payment">Pembayaran</label> &nbsp;&nbsp;&nbsp;
                    <input type="radio" v-model="category" id="discount" value="disc"> <label for="discount">Potongan</label>
                </Form-item>
                <Form-item label="Kategori"
                    v-show="paymentDate !='' && markingIdSelected != '' && invoiceDues.length > 0 && paymentClaimId">
                    <input type="radio" v-model="category" id="payment" value="pay"> <label for="payment">Pembayaran</label> &nbsp;&nbsp;&nbsp;
                </Form-item>

                <Alert v-show="depositAmount != 0"
                    type="warning" show-icon
                    style="width: 300px;">Kelebihan : {{depositAmount | currency}}</Alert>

                <Alert v-show="depositAmount != 0 && category == 'disc'"
                    type="error" show-icon style="width: 700px;"> Tidak dapat melanjutkan proses pembayaran jika terdapat Kelebihan pada Kategori Potongan.</Alert>
                <Alert v-show="depositAmount > paymentClaimAmount && paymentClaimId"
                    type="error" show-icon style="width: 700px;"> Tidak dapat melanjutkan proses pembayaran jika Alokasi Pembayaran lebih besar dari Mutasi.</Alert>

            </Form>
        </Card>

        <br/>

        <Card v-show="this.invoiceDues.length > 0">
            <p slot="title"> Daftar Invoice </p>

            <Row type="flex" class="code-row-bg">
                <template v-if="paymentClaimId == null">
                    <Col span="2" v-if="isGroup"> Marking </Col>
                    <Col span="2"> Tgl Bongkar </Col>
                    <Col span="6"> Keterangan </Col>
                    <Col span="4"> Total </Col>
                    <Col span="3"> Sisa </Col>
                    <Col span="5"> Alokasi Pembayaran </Col>
                </template>
                <template v-if="paymentClaimId">
                    <Col span="2" v-if="isGroup"> Marking </Col>
                    <Col span="2"> Tgl Bongkar </Col>
                    <Col span="6"> Keterangan </Col>
                    <Col span="3"> Total </Col>
                    <Col span="3"> Sisa </Col>
                    <Col span="3"> Alokasi Pembayaran </Col>
                    <Col span="5"> Potongan </Col>
                </template>
            </Row>

            <br/> <hr/> <br/>

            <div v-for="invoiceDue in invoiceDues" :key="invoiceDue.id">
                <cInvoicePayment
                    :invoiceDue="invoiceDue"
                    :depositRemaining="depositRemaining"
                    :paymentClaimId="paymentClaimId"
                    :paymentClaimAmount="paymentClaimAmount"
                    @setAllocateAmount="setAllocateAmount">
                </cInvoicePayment>
                <br/>
            </div>
        </Card>

        <div class="footer" v-show="isGroup == false" >
            <Button v-show="description !='' && category != '' && ((totalUseDepositAmount <= depositRemaining) || depositRemaining < 0) && paymentClaimId == null"
                type="primary"
                :loading="loadingPost"
                @click="postPayment"
                icon="checkmark-round"
                size="small">
                    <span v-if="!loadingPost && amountReceived + totalUseDepositAmount > 0">Bayar</span>
                    <span v-else-if="!loadingPost && (amountReceived == 0)">Bayar Free</span>
                    <span v-else>Wait.....</span>
            </Button>
        </div>
        <div class="footer" v-show="isGroup == false" >
            <Button v-show="description !='' && category != '' && ((totalUseDepositAmount <= depositRemaining) || depositRemaining < 0) && ((depositAmount == 0 && category == 'disc') || (depositAmount >= 0 && category == 'pay')) && ((paymentClaimId && depositAmount <= paymentClaimAmount) || paymentClaimId == null)"
                type="primary"
                :loading="loadingPost"
                @click="postPaymentClaim"
                icon="checkmark-round"
                size="small"  >
                    <span v-if="!loadingPost && amountReceived + totalUseDepositAmount > 0">Bayar</span>
                    <span v-else-if="!loadingPost && (amountReceived == 0)">Bayar Free</span>
                    <span v-else>Wait.....</span>
            </Button>
        </div>
        <div class="footer" v-show="isGroup">
            <Button v-show="description !='' && category != '' && ((totalUseDepositAmount <= depositRemaining) || depositRemaining < 0)"
                type="primary"
                :loading="loadingPost"
                @click="postPaymentByGroup"
                icon="checkmark-round"
                size="small"  >
                    <span v-if="!loadingPost && amountReceived + totalUseDepositAmount > 0">Bayar</span>
                    <span v-else-if="!loadingPost && (amountReceived == 0)">Bayar Free</span>
                    <span v-else>Wait.....</span>
            </Button>
        </div>

        <Modal v-model="modalConfirmDeposit" width="500px" @on-cancel="depositType= ''">
            <p slot="header" style="color:#2d8cf0;text-align:center">
                <Icon type="information-circled"></Icon>
                <span>Konfirmasi</span>
            </p>
            Kelebihan <b>{{ depositAmount | currency }}</b> akan dijadikan sebagai :
            <div style="text-align:left">
                <RadioGroup v-model="depositType" vertical>
                    <Radio label="DEP">
                        <span>Deposit</span>
                    </Radio>
                    <Radio label="PRF">
                        <span>Pendapatan</span>
                    </Radio>
                </RadioGroup>
            </div>
            <div slot="footer" v-show="isGroup == false && paymentClaimId == null">
                <Button
                    v-show="depositType != ''"
                    type="primary"
                    long
                    :loading="loadingPost"
                    @click="postPayment" >
                    <span v-if="!loadingPost">Bayar</span>
                    <span v-else>Wait.....</span>
                </Button>
            </div>
            <div slot="footer" v-show="isGroup == false && paymentClaimId">
                <Button
                    v-show="depositType != ''"
                    type="primary"
                    long
                    :loading="loadingPost"
                    @click="postPaymentClaim" >
                    <span v-if="!loadingPost">Bayar</span>
                    <span v-else>Wait.....</span>
                </Button>
            </div>
            <div slot="footer" v-show="isGroup">
                <Button
                    v-show="depositType != ''"
                    type="primary"
                    long
                    :loading="loadingPost"
                    @click="postPaymentByGroup" >
                    <span v-if="!loadingPost">Bayar</span>
                    <span v-else>Wait.....</span>
                </Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import {HTTP} from '../http-lib';
import {Money} from 'v-money'
import _ from 'lodash'

import moment from 'moment'
import cInvoicePayment from '@/components/claim/cInvoicePayment'

const numeral = require('numeral');
var axios = require('axios');

export default {
    components : {cInvoicePayment, Money},
    props: {
        paymentClaimId : Number,
        paymentDateProp : String,
        paymentClaimAmount : Number,
        paymentClaimMarking : String,
    },

    data: () => ({
        paymentDate : '',
        optionMarkings : [],
        optionGroupMarkings : [],
        modalConfirmDeposit: false,
        amountReceived : '',
        discountReceived : '',
        amountResidue : '',
        depositType : '',
        depositAmount : '', // untuk menampung kelebihan bayar
        depositRemaining : 0, // untuk menampung total sisa deposit
        totalUseDepositAmount : 0,
        loadingGetPayment : false,
        accountNumber : '',
        description : '',
        transactionDate : '',
        markingIdSelected : '',
        loadingGetMarking: false,
        invoiceDues : [],
        loadingPost : false,
        paymentAllocates : [],
        postData : [],
        payments : [],
        searchSelectSubbranch : localStorage.getItem('user.subbranchcode'),
        subbranchs: '',
        isGroup : false,
        tableColumns: [
            {
                title: 'Tgl',
                key: 'paymentDate',
                sortable: false
            },
            {
                title: 'Marking',
                key: 'markingHeaderId',
                sortable: false
            },
            {
                title: 'Keterangan',
                key: 'description',
                sortable: false
            },
            {
                title: 'Jumlah',
                key: 'creditAmount',
                sortable: false
            }
        ],
        filterInput : '',
        money: {
          decimal: ',',
          thousands: '.',
          prefix: '',
          suffix: '',
          precision: 0,
          masked: false
        },
        category: '',
        paymentClaim : Object,
        finishLoading: false
    }),
    methods: {
        isDeviation : function(invoiceDue){
            if(invoiceDue.allocateAmount + invoiceDue.useDepositAmount > invoiceDue.receivableRemaining){
                return true;
            }
            return false;
        },
        countTotalAllocateAmount: function(invoiceDue){
            return (invoiceDue.allocateAmount + invoiceDue.useDepositAmount) - invoiceDue.receivableRemaining;
        },
        setAllocateAmount : function(invoiceDue){
            if(this.isDeviation(invoiceDue)){
                invoiceDue.deviationAmount = this.countTotalAllocateAmount(invoiceDue)
            } else {
                invoiceDue.deviationAmount = 0
            }

            console.log(invoiceDue)

            var index = _.findIndex(this.invoiceDues, {id: invoiceDue.id});

            // Replace item at index using native splice
            this.invoiceDues.splice(index, 1, invoiceDue);

            // var invoiceDueChanged = _.find(this.invoiceDues, {id: invoiceDue.id});
            this.setResidueAmount(true);
        },
        setResidueAmount : function(fromChild){
            let allocateAmounts = _.sumBy(this.invoiceDues, 'allocateAmount');
            let allocateDiscountAmounts = _.sumBy(this.invoiceDues, 'discountAmount');
            this.amountResidue = this.amountReceived - allocateAmounts;

            if(fromChild){
                this.amountReceived = allocateAmounts;
                this.totalUseDepositAmount = _.sumBy(this.invoiceDues, 'useDepositAmount');

                this.discountReceived = allocateDiscountAmounts;
            }

            let sumDeviation = _.sumBy(this.invoiceDues, 'deviationAmount');
            this.depositAmount = sumDeviation
        },
        getDepositRemaining: function(){
            if(this.markingIdSelected !== ''){
                return HTTP.get('deposit/remaining/' + this.markingIdSelected)
            } else {
                this.depositRemaining = 0;
            }
        },

        getInvoiceDueUnSettled: function(){
            if(this.markingIdSelected !== ''){
                return HTTP.get('invoiceDue/unsettled/' + this.markingIdSelected)
            } else {
                this.invoiceDues = []
            }
        },
        getInvoiceDueUnSettledByGroup: function(){
            if(this.markingIdSelected !== ''){
                return HTTP.get('invoiceDue/unsettledByGroup/' + this.markingIdSelected)
            } else {
                this.invoiceDues = []
            }
        },
        getSubbranch: function(){
                HTTP
                .get('subbranch')
                .then(response => {
                    this.subbranchs = response.data
                })
                .catch(e => {
                    //console.log(e);
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
        },

        getInvoiceData: function(){
            this.loadingGetPayment  = true;

            this.invoiceDues = []
            this.amountResidue = ''
            // this.amountReceived = ''
            this.description = ''
            this.depositRemaining = 0;
            this.totalUseDepositAmount = 0;

            if(this.markingIdSelected == ''){
                this.loadingGetPayment = false;
                return;
            }

            let parent = this;

            axios.all([
                this.getInvoiceDueUnSettled(),
                this.getDepositRemaining()
            ]).then(axios.spread((unSettledRes, depositRemainingRes) => {
                let invoiceDuesFormatted = []
                console.log({unSettledRes});

                _.forEach(unSettledRes.data, function(value) {
                    // console.log(value.id)

                    let receivableType = value.receivable.type;

                    let invoicefee = value.receivable.debitAmount;
                    let invoicedate = value.receivable.transactionDate;
                    let invoicedatedue = '';

                    if(receivableType != 'MAN'){
                        let invoicefee = value.receivable.invoice.invoicefee;
                        let invoicedatedue = value.receivable.invoice.invoicedatedue;
                        let invoicedate = value.receivable.invoice.invoicedate;
                    }

                    let paymentSum = value.paymentSum;
                    let receivableRemaining = invoicefee - paymentSum;
                    let receivableDebitAmount = value.receivable.debitAmount;

                    let payment = {
                        id : value.id,
                        receivableId : value.receivableId,
                        invoicefee : invoicefee, // Jika ada invoice, nilai ini dapat berubah jika repricing
                        paymentSum : paymentSum,
                        receivableRemaining : receivableRemaining,
                        description : value.receivable.description,
                        invoicedate : invoicedate, //numeral(value.receivable.creditAmount).format('0,0')
                        invoicedatedue : invoicedatedue,
                        receivableDebitAmount : receivableDebitAmount, // menyimpan nilai awal
                        allocateAmount : 0,
                        deviationAmount : 0, // untuk menyimpan kelebihan bayar
                        useDepositAmount : 0, // nilai penggunaan deposit (jika ada deposit)
                        markingHeaderId : value.receivable.markingHeaderId,
                        claimAmount : 0,
                        discountAmount : 0
                    }

                    invoiceDuesFormatted.push(payment);
                });

                if(invoiceDuesFormatted.length > 0) {
                    invoiceDuesFormatted = _.sortBy(invoiceDuesFormatted, ['invoicedate'], function(value) {return new Date(value);});

                    let claimAmount = this.paymentClaimAmount;
                    let index = 0;

                    if(claimAmount && claimAmount > 0) {
                      _.forEach(invoiceDuesFormatted, function(value) {
                        if (claimAmount && claimAmount > 0 && claimAmount > value.receivableRemaining ) {
                          invoiceDuesFormatted[index].claimAmount = value.receivableRemaining;
                          claimAmount = claimAmount - value.receivableRemaining;
                        } else if (claimAmount && claimAmount > 0 && claimAmount <= value.receivableRemaining) {
                          invoiceDuesFormatted[index].claimAmount = claimAmount;
                          claimAmount = 0;
                        }

                        index++;
                      });
                    }

                    parent.invoiceDues =  invoiceDuesFormatted;
                    parent.depositRemaining = depositRemainingRes.data.remaining
                    console.log('parent.invoiceDues : ', parent.invoiceDues);
                } else {
                    if(this.markingIdSelected){
                            this.$Message.info('Piutang tidak ditemukan');
                        // parent.$Notice.error({
                        //     title: '',
                        //     desc: 'Piutang tidak ditemukan',
                        //     duration: 5
                        // });
                    }
                }
                parent.loadingGetPayment = false;
            }))
            .catch(e => {
              console.log(e)
                this.loadingGetPayment = false;
                this.$Notice.error({
                    title: "Error",
                    desc: 'Silahkan Cek Menu Piutang > Hapus Piutang',
                    duration: 0
                });
            });
        },

        getInvoiceDataByGroupMarking: function(){
            this.loadingGetPayment  = true;

            this.invoiceDues = []
            this.amountResidue = ''
            this.amountReceived = ''
            this.description = ''
            this.depositRemaining = 0;
            this.totalUseDepositAmount = 0;

            if(this.markingIdSelected == ''){
                this.loadingGetPayment = false;
                return;
            }

            let parent = this;

            axios.all([
                this.getInvoiceDueUnSettledByGroup(),
                this.getDepositRemaining()
            ]).then(axios.spread((unSettledRes, depositRemainingRes) => {
                let invoiceDuesFormatted = []
                console.log({unSettledRes});
                _.forEach(unSettledRes.data, function(value) {
                    // console.log(value.id)

                    let receivableType = value.receivable.type;

                    let invoicefee = value.receivable.debitAmount;
                    let invoicedate = value.receivable.transactionDate;
                    let invoicedatedue = '';

                    if(receivableType != 'MAN'){
                        let invoicefee = value.receivable.invoice.invoicefee;
                        let invoicedatedue = value.receivable.invoice.invoicedatedue;
                        let invoicedate = value.receivable.invoice.invoicedate;
                    }

                    let paymentSum = value.paymentSum;
                    let receivableRemaining = invoicefee - paymentSum;
                    let receivableDebitAmount = value.receivable.debitAmount;

                    let payment = {
                        id : value.id,
                        receivableId : value.receivableId,
                        invoicefee : invoicefee, // Jika ada invoice, nilai ini dapat berubah jika repricing
                        paymentSum : paymentSum,
                        receivableRemaining : receivableRemaining,
                        description : value.receivable.description,
                        invoicedate : invoicedate, //numeral(value.receivable.creditAmount).format('0,0')
                        invoicedatedue : invoicedatedue,
                        receivableDebitAmount : receivableDebitAmount, // menyimpan nilai awal
                        allocateAmount : 0,
                        deviationAmount : 0, // untuk menyimpan kelebihan bayar
                        useDepositAmount : 0, // nilai penggunaan deposit (jika ada deposit)
                        markingHeaderId : value.receivable.markingHeaderId,
                        markingHeaderCode : value.receivable.marking_minified.markingheadercode,
                    }

                    invoiceDuesFormatted.push(payment);
                });

                if(invoiceDuesFormatted.length > 0) {
                    invoiceDuesFormatted = _.sortBy(invoiceDuesFormatted, ['invoicedate'], function(value) {return new Date(value);});
                    parent.invoiceDues =  invoiceDuesFormatted;
                    parent.depositRemaining = depositRemainingRes.data.remaining
                } else {
                    if(this.markingIdSelected){
                            this.$Message.info('Piutang tidak ditemukan');
                        // parent.$Notice.error({
                        //     title: '',
                        //     desc: 'Piutang tidak ditemukan',
                        //     duration: 5
                        // });
                    }
                }
                parent.loadingGetPayment = false;
            }))
            .catch(e => {
                this.loadingGetPayment = false;
                this.$Notice.error({
                    title: "Error",
                    desc: 'Silahkan Cek Menu Piutang > Hapus Piutang',
                    duration: 0
                });
            });
        },

        postPayment: function(){

            if(this.depositAmount > 0 && this.depositType==''){
                this.modalConfirmDeposit = true;
                return;
            } else {
                this.modalConfirmDeposit = false;
            }

            this.loadingPost = true
            let paymentAllocates = [];
            _.forEach(this.invoiceDues, function(invoiceDue) {
                if(invoiceDue.allocateAmount + invoiceDue.useDepositAmount != 0 ||
                    invoiceDue.invoicefee == 0)
                {
                    let paymentAllocate = {
                        invoicefee : invoiceDue.invoicefee,
                        invoiceDueId : invoiceDue.id,
                        allocateAmount : invoiceDue.allocateAmount,
                        receivableRemaining : invoiceDue.receivableRemaining,
                        useDepositAmount : invoiceDue.useDepositAmount,
                    }
                    paymentAllocates.push(paymentAllocate);
                }
            });

            let subbranchcode = this.searchSelectSubbranch;
            let branchcode = this.searchSelectSubbranch;

            console.log(this.amountReceived)
            this.paymentAllocates = paymentAllocates;
            let transactionDate = moment(this.paymentDate).format('YYYY/MM/DD')
            HTTP
            .post('payment/pay', {
                markingHeaderId: this.markingIdSelected,
                amount : this.amountReceived,
                transactionDate : transactionDate,
                description : this.description,
                accountNumber : this.accountNumber,
                depositAmount : this.depositAmount,
                paymentAllocates : this.paymentAllocates,
                depositType: this.depositType,
                category: this.category,
                paymentClaimId: this.paymentClaimId
            })
            .then(response => {
                this.loadingPost = false

                this.$Message.success({
                    content: 'Pembayaran Berhasil',
                    duration: 5
                });

                if(this.paymentClaimId)
                    this.goToPaymentClaimList()
                else
                    this.getInvoiceData();
            })
            .catch(e => {
                this.loadingPost = false
                this.$Notice.error({
                    title: "Error",
                    desc: e,
                    duration: 5
                });
            })
        },
        postPaymentClaim: function(){

            if(this.depositAmount > 0 && this.depositType==''){
                this.modalConfirmDeposit = true;
                return;
            } else {
                this.modalConfirmDeposit = false;
            }

            this.loadingPost = true
            let paymentAllocates = [];
            let paymentDiscountAllocates = [];
            _.forEach(this.invoiceDues, function(invoiceDue) {
                if(invoiceDue.allocateAmount + invoiceDue.useDepositAmount != 0 ||
                    invoiceDue.invoicefee == 0)
                {
                    let paymentAllocate = {
                        invoicefee : invoiceDue.invoicefee,
                        invoiceDueId : invoiceDue.id,
                        allocateAmount : invoiceDue.allocateAmount,
                        receivableRemaining : invoiceDue.receivableRemaining,
                        useDepositAmount : invoiceDue.useDepositAmount,
                    }
                    paymentAllocates.push(paymentAllocate);
                }

                if((invoiceDue.allocateAmount + invoiceDue.useDepositAmount != 0 ||
                    invoiceDue.invoicefee == 0) && (invoiceDue.discountAmount && invoiceDue.discountDescription))
                {
                    let paymentAllocate = {
                        invoicefee : invoiceDue.invoicefee,
                        invoiceDueId : invoiceDue.id,
                        allocateAmount : invoiceDue.discountAmount,
                        receivableRemaining : invoiceDue.receivableRemaining,
                        useDepositAmount : 0,
                        description : invoiceDue.discountDescription,
                    }
                    paymentDiscountAllocates.push(paymentAllocate);
                }
            });

            console.log(this.amountReceived)
            this.paymentAllocates = paymentAllocates;
            let transactionDate = moment(this.paymentDate).format('YYYY/MM/DD')
            HTTP
            .post('payment/pay', {
                markingHeaderId: this.markingIdSelected,
                amount : this.amountReceived,
                transactionDate : transactionDate,
                description : this.description,
                accountNumber : this.accountNumber,
                depositAmount : this.depositAmount,
                paymentAllocates : this.paymentAllocates,
                depositType: this.depositType,
                category: this.category,
                paymentClaimId: this.paymentClaimId,
                paymentDiscountAllocates : paymentDiscountAllocates
            })
            .then(response => {
                this.loadingPost = false

                this.$Message.success({
                    content: 'Pembayaran Berhasil',
                    duration: 5
                });

                if(this.paymentClaimId)
                    this.goToPaymentClaimList()
                else
                    this.getInvoiceData();
            })
            .catch(e => {
                this.loadingPost = false
                this.$Notice.error({
                    title: "Error",
                    desc: e,
                    duration: 5
                });
            })
        },
        postPaymentByGroup: function(){

            if(this.depositAmount > 0 && this.depositType==''){
                this.modalConfirmDeposit = true;
                return;
            } else {
                this.modalConfirmDeposit = false;
            }

            var subbranchcode = this.searchSelectSubbranch;
            var branchcode = this.searchSelectSubbranch;
            var paymentDate = this.paymentDate;
            var amountReceived = this.amountReceived;
            var transactionDate = this.transactionDate;
            var description = this.description;
            var accountNumber = this.accountNumber;
            var depositAmount = this.depositAmount;
            var depositType = this.depositType;
            var category = this.category;
            var paymentClaimId = this.paymentClaimId;

            var groupByCategory = _.groupBy(this.invoiceDues, invoiceDue => invoiceDue.markingHeaderId);
            this.loadingPost = true

            var isResponse = true;
            var isDescriptionResponse = '';

            _.forEach(groupByCategory, function(invoiceDue) {
              let paymentAllocates = [];
              var markingheaderid = '';
              _.forEach(invoiceDue, function(invoiceDue) {

                  if(invoiceDue.allocateAmount + invoiceDue.useDepositAmount != 0 ||
                    invoiceDue.invoicefee == 0)
                  {
                        let paymentAllocate = {
                            invoicefee : invoiceDue.invoicefee,
                            invoiceDueId : invoiceDue.id,
                            allocateAmount : invoiceDue.allocateAmount,
                            receivableRemaining : invoiceDue.receivableRemaining,
                            useDepositAmount : invoiceDue.useDepositAmount,
                        }
                        paymentAllocates.push(paymentAllocate);
                  }

                  markingheaderid = invoiceDue.markingHeaderId;

              });

              console.log(groupByCategory)

              // let subbranchcode = this.searchSelectSubbranch;
              // let branchcode = this.searchSelectSubbranch;

              // this.paymentAllocates = paymentAllocates;
              let transactionDate = moment(paymentDate).format('YYYY/MM/DD')
              HTTP
              .post('payment/pay', {
                  markingHeaderId: markingheaderid,
                  amount : amountReceived,
                  transactionDate : transactionDate,
                  description : description,
                  accountNumber : accountNumber,
                  depositAmount : depositAmount,
                  paymentAllocates : paymentAllocates,
                  depositType: depositType,
                  category: category,
                  paymentClaimId: paymentClaimId
              })
              .then(response => {
                  isResponse = true;
              })
              .catch(e => {
                  isSuccess = true;
                  isDescriptionResponse = e;
              })
            });

            if(isResponse) {
              this.loadingPost = false

              this.$Message.success({
                  content: 'Pembayaran Berhasil',
                  duration: 5
              });
            } else {
              this.loadingPost = false

              this.$Notice.error({
                  title: "Error",
                  desc: isDescriptionResponse,
                  duration: 5
              });
            }

            if(this.paymentClaimId)
                this.goToPaymentClaimList()
            else
                this.getInvoiceDataByGroupMarking();
        },

        getMarkingByCode: _.debounce(
            function (query) {
                if (query && query !== '' && this.isGroup == false) {
                    this.loadingGetMarking = true;
                    HTTP
                    .post('marking/getBySnapshot', {
                        markingHeaderId: query,
                        subbranchcode: this.searchSelectSubbranch || null
                    })
                    .then(response => {
                        this.loadingGetMarking = false;
                        let data = response.data;

                        const list = data.map(item => {
                            return {
                                value: item.markingheaderid,
                                label: item.markingheadercode
                            };
                        });

                        this.optionMarkings = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);
                    })
                    .catch(e => {
                        this.$Notice.error({
                            title: "Error",
                            desc: e,
                            duration: 5
                        });
                    })
                } else {
                    this.optionMarkings = [];
                }
            }, 300
        ),
        getMarkingClaimByCode: _.debounce(
            function (query) {
                if (query !== '' && this.isGroup == false) {
                    this.loadingGetMarking = true;
                    HTTP
                    .post('marking/getBySnapshot', {
                        markingHeaderId: this.paymentClaimMarking,
                        subbranchcode: this.searchSelectSubbranch || null
                    })
                    .then(response => {
                        this.loadingGetMarking = false;
                        let data = response.data;

                        if(this.paymentClaimMarking) {
                          this.markingIdSelected = data[0].markingheaderid
                          this.paymentClaimMarking = data[0].markingheadercode
                        }
                    })
                    .catch(e => {
                        this.$Notice.error({
                            title: "Error",
                            desc: e,
                            duration: 5
                        });
                    })
                } else {
                    this.optionMarkings = [];
                }
            }, 300
        ),
        getGroupMarkingByCode:  _.debounce(
            function (query) {
                if (query !== '' && this.isGroup) {
                    this.loadingGetMarking = true;
                    HTTP
                    .post('markingGroup/getByCode', {
                        groupName: query
                    })
                    .then(response => {
                        this.loadingGetMarking = false;
                        let data = response.data;

                        const list = data.map(item => {
                            return {
                                value: item.id,
                                label: item.code
                            };
                        });

                        this.optionGroupMarkings = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);
                    })
                    .catch(e => {
                        this.$Notice.error({
                            title: "Error",
                            desc: e,
                            duration: 5
                        });
                    })
                } else {
                    this.optionGroupMarkings = [];
                }
            }, 300
        ),
        getPaymentClaim: function(){
            this.finishLoading = false
            let urlFindByFilter = 'claim/id/' + this.paymentClaimId;

            HTTP
            .get(urlFindByFilter)
            .then(response => {
                let value = response.data
                console.log({value});

                this.paymentClaim = {
                    id : value.id,
                    amount : value.total_claim,
                    transactionDate : null,
                    bankAccountName : null
                }

                this.finishLoading = true
            })
            .catch(e => {
                this.finishLoading = true
                this.loadingSearch = false;
                this.$Notice.error({
                    title: "Error",
                    desc: e,
                    duration: 5
                });
            })
        },
        goToPaymentClaimList: function(){
            this.$router.push({ path: '/claim/list' })
        },
        setMarkingCode: function(){
            this.markingIdSelected = ''
        },
    },
    filters: {
        currency: function (value) {
        if (!value) return ''
        return numeral(value).format('0,0')
        }
    } ,
    beforeMount() {
        this.paymentDate = this.paymentDateProp // set & handle mutating a prop directly
        this.amountReceived = this.paymentClaimAmount;
        this.getMarkingClaimByCode()
    },
    watch: {
        amountReceived: function (newAmountReceived) {
            console.log({newAmountReceived});
        this.setResidueAmount(false)
        }
    },
    created() {
        this.getSubbranch();
        this.getPaymentClaim();
    }
}

</script>



// WEBPACK FOOTER //
// ClaimPaymentAdd.vue?226b55b4